var uniqueStr = () => {
  var rand = Math.random();
  var rand2 = Math.random();
  var now = Date.now();
  var randAdj = rand + Math.floor(rand2 * 10);
  return "xorc-uid-".concat(randAdj).concat(now).replace(/\./g, 'n');
};

export { uniqueStr };